Vue.directive('listen-show', {
  inserted: (el, binding, vnode) => {
    binding.value.onBind(el, binding, vnode)
  },
  componentUpdated: (el, binding, vnode) => {
    binding.value.onBind(el, binding, vnode)
  },
  unbind: (el, binding, vnode) => {
    binding.value.onUnbind(el, binding, vnode)
  }
})

/**
 * show 检测工具类
 */
export class ShowLogTools {
  constructor () {
    this.intersectionObserver = null
    // 需要观测的节点
    this.nodeSet = {}
    // 记录节点展示的时间戳，用于是否展示过的判断
    this.showSet = {}
    // 最新新增的，还未处理过的已展示节点
    this.showedItems = []
  }

  // #region 开始观测 与 停止观测
  setObserver (observer) {
    this.intersectionObserver = observer
  }

  disconnect () {
    return this.intersectionObserver?.disconnect()
  }
  // #endregion

  // #region 观测 与 取消观测 元素
  observe (el) {
    return this.intersectionObserver?.observe(el)
  }

  observeElement (el) {
    if (this.showSet[el?.dataset?.showUuid]) {
      this.unobserveElement(el)
      return
    }
    this.observe(el)
  }

  unobserveElement (el) {
    return this.intersectionObserver?.unobserve(el)
  }
  // #endregion

  // #region 初始化 与 清空 待观测节点
  initNodeSet (list, getUUID = null) {
    this.clearNodeSet()
    list.forEach((item, index) => {
      if (getUUID) index = getUUID(item)
      this.nodeSet[index] = item
      this.showSet[index] = 0
    })
  }

  clearNodeSet () {
    this.nodeSet = {}
    this.showSet = {}
    this.showedItems = []
  }

  updateNodeShow (uuid) {
    if (uuid && this.nodeSet[uuid]) {
      this.showSet[uuid] = Date.now()
      return this.nodeSet[uuid]
    }
    return null
  }
  // #endregion

  // #region 追加 与 清空 已展示节点
  appendShowedItems (items) {
    this.showedItems.push(...items)
  }

  clearShowedItems () {
    this.showedItems = []
  }
  // #endregion
}
